<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Mechanical Connections</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        <div class="halfWidthConfigurationInput">
          @if (returnAirLocationSelection) {
            <div class="modConnectionRow">
              <label class="modConnectionLabel">Arrangement:</label>
              <select class="modConnectionField" #returnLocationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnAirLocationSelection.Name)"
                (change)="selectionChanged(returnAirLocationSelection, returnLocationInput.value)"
                [value]="returnAirLocationSelection.Value.toString()">
                @for (allowable of returnAirLocationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnAirLocationSelection.Value && returnAirLocationSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (frontSupplySelection) {
            <div class="modConnectionRow">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(frontSupplySelection.Name)"
              for="frontSupplyInput" class="modConnectionLabel">Front Supply:</label>
              <input type="checkbox" class="checkboxInput" id="frontSupplyInput"
                #frontSupplyInput [checked]="'true' === frontSupplySelection.Value"
                (change)="selectionChanged(frontSupplySelection, frontSupplyInput.checked.toString())">
              @if (topSupplySelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(topSupplySelection.Name)"
                  for="topSupplyInput" class="modConnectionCheckboxLabel">Top Supply:</label>
                  <input type="checkbox" class="checkboxInput" id="topSupplyInput"
                    #topSupplyInput [checked]="'true' === topSupplySelection.Value"
                    (change)="selectionChanged(topSupplySelection, topSupplyInput.checked.toString())">
                </span>
              }
            </div>
          }
          @if (leftSupplySelection) {
            <div class="modConnectionRow">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(leftSupplySelection.Name)"
              for="leftSupplyInput" class="halfWidthInputLabel">Left Supply:</label>
              <input type="checkbox" class="checkboxInput" id="leftSupplyInput"
                #leftSupplyInput [checked]="'true' === leftSupplySelection.Value"
                (change)="selectionChanged(leftSupplySelection, leftSupplyInput.checked.toString())">
              @if (rightSupplySelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(rightSupplySelection.Name)"
                  for="rightSupplyInput" class="modConnectionCheckboxLabel">Right Supply:</label>
                  <input type="checkbox" class="checkboxInput" id="rightSupplyInput"
                    #rightSupplyInput [checked]="'true' === rightSupplySelection.Value"
                    (change)="selectionChanged(rightSupplySelection, rightSupplyInput.checked.toString())">
                </span>
              }
            </div>
          }
          @if (returnAirStyleSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Return Style:</label>
              <select class="halfWidthInputField" #returnStyleInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnAirStyleSelection.Name)"
                (change)="selectionChanged(returnAirStyleSelection, returnStyleInput.value)"
                [value]="returnAirStyleSelection.Value.toString()">
                @for (allowable of returnAirStyleSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnAirStyleSelection.Value && returnAirStyleSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (returnPanelFinishSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Return Air Panel Finish:</label>
              <select class="halfWidthInputField" #returnPanelFinishInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnPanelFinishSelection.Name)"
                (change)="selectionChanged(returnPanelFinishSelection, returnPanelFinishInput.value)"
                [value]="returnPanelFinishSelection.Value.toString()">
                @for (allowable of returnPanelFinishSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnPanelFinishSelection.Value && returnPanelFinishSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (supplyTypeSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Supply Type:</label>
              <select class="halfWidthInputField" #supplyTypeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(supplyTypeSelection.Name)"
                (change)="selectionChanged(supplyTypeSelection, supplyTypeInput.value)"
                [value]="supplyTypeSelection.Value.toString()">
                @for (allowable of supplyTypeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="supplyTypeSelection.Value && supplyTypeSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (supplyGrilleFinishSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Supply Air Grille Finish:</label>
              <select class="halfWidthInputField" #supplyGrilleFinishInput
                [class.invalidConfigurationSelection]="isInvalidSelection(supplyGrilleFinishSelection.Name)"
                (change)="selectionChanged(supplyGrilleFinishSelection, supplyGrilleFinishInput.value)"
                [value]="supplyGrilleFinishSelection.Value.toString()">
                @for (allowable of supplyGrilleFinishSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="supplyGrilleFinishSelection.Value && supplyGrilleFinishSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (paintOptionsSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Paint Options:</label>
              <select class="halfWidthInputField" #paintOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(paintOptionsSelection.Name)"
                (change)="selectionChanged(paintOptionsSelection, paintOptionsInput.value)"
                [value]="paintOptionsSelection.Value.toString()">
                @for (allowable of paintOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="paintOptionsSelection.Value && paintOptionsSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
        </div>
        <div class="halfWidthConfigurationInput">
          @if (pipeDetailImagePath() && pipeDetailImagePath().length > 0) {
            <img class="pipeDetailImage"
              [src]="pipeDetailImagePath()" alt="PipeDetailImage"/>
          }
          @if (handArrangementImagePath() && handArrangementImagePath().length > 0) {
            <img class="handArrangementImage"
              [src]="handArrangementImagePath()" alt="ArrangementImage"/>
          }
        </div>
      </div>
    </div>
  }
</div>
